import React, { useEffect, useState } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { arrayMoveImmutable } from "array-move";
import { Spinner } from "react-bootstrap";
import CPPhoto from "./CPPhoto";
import { toast } from "react-toastify";
import { useUpdateCoverPictureMutation } from "../../../../rtk-query/slices/createProduct/ProductInfo/productInfoSlice";
import { useNavigate } from "react-router-dom";

// Sortable Photo component
const SortablePhoto = SortableElement(
  ({ res, handleRemovePhoto, productId }) => (
    <CPPhoto
      res={res}
      handleRemovePhoto={handleRemovePhoto}
      productId={productId}
    />
  )
);

// Sortable Photos List container
const SortablePhotosList = SortableContainer(
  ({ photos, handleRemovePhoto, productId }) => {
    return (
      <div className="cp-selected-photos">
        {photos.map((res, index) => (
          <SortablePhoto
            key={res.image_id} // Use unique `image_id` for key
            index={index} // SortableHOC uses index for sorting
            res={res}
            handleRemovePhoto={handleRemovePhoto}
            productId={productId}
          />
        ))}
      </div>
    );
  }
);

const CPSelectedPhotosContainer = ({
  photos,
  handleClickAddPhoto,
  handleRemovePhoto,
  isLoading,
  productId,
}) => {
  const navigate = useNavigate();
  const [updateCoverPicture] = useUpdateCoverPictureMutation();
  const [sortedPhotos, setSortedPhotos] = useState([]); // Handle sorting after drag-and-drop

  const onSortEnd = async ({ oldIndex, newIndex }) => {
    // Get the dragged item using the oldIndex
    const draggedItem = sortedPhotos[oldIndex];
    const newSortedPhotos = arrayMoveImmutable(
      sortedPhotos,
      oldIndex,
      newIndex
    );
    setSortedPhotos(newSortedPhotos);
    try {
      const formData = new FormData();

      formData.append("product_id", productId || localStorage.getItem("productId") || null); // Ensure this key is correct based on your API
      formData.append("is_default_image", draggedItem?.is_default_image);
      formData.append("picture_id", draggedItem?.image_id);
      formData.append("sort_order", newIndex);
      formData.append("type", "1");

      const response = await updateCoverPicture(formData);

      if (response?.data?.status) {
        toast.success(response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
        // navigate("/");
      }
      if (response?.error) {
        const errors = response?.error?.data?.errors;
        if (response?.error?.status === 401) {
          localStorage.removeItem("DODLoginToken");
          toast.error(response?.error?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
          navigate("/login");
        } else if (errors) {
          for (const field in errors) {
            if (errors.hasOwnProperty(field)) {
              // const combinedErrors = errors[field].join(" ");
              // if (field === "supplier_type") {
              //   setFieldError("option", combinedErrors);
              // }
            }
          }
          toast.error(response?.error?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
        } else {
          toast.error(response?.error?.data?.message, {
            position: "top-center",
            autoClose: 3000,
          });
        }
      }
    } catch (error) {
      console.log(error);
      toast.error("An unexpected error occurred. Please try again.", {
        position: "top-center",
        autoClose: 3000,
      });
    }
    // console.log(newIndex);
    // const newSortedPhotos = arrayMoveImmutable(
    //   sortedPhotos,
    //   oldIndex,
    //   newIndex
    // );
    // setSortedPhotos(newSortedPhotos);
  };

  useEffect(() => {
    const sorted = [...photos].sort((a, b) => {
      // First, check if either a or b has is_default = 1
      if (a.is_default_image === 1 && b.is_default_image !== 1) return -1; // a should come first
      if (a.is_default_image !== 1 && b.is_default_image === 1) return 1; // b should come first

      // If both have the same is_default value, sort by sort_order
      return a.sort_order - b.sort_order;
    });

    setSortedPhotos(sorted);
  }, [photos]);

  return (
    <div className="cp-selected-photos-container">
      <SortablePhotosList
        photos={sortedPhotos}
        handleRemovePhoto={handleRemovePhoto}
        productId={productId}
        onSortEnd={onSortEnd}
        axis="xy" // Allows dragging in both x and y directions
        lockAxis="xy"
      />
      <button
        className="cp-selected-photos-add-more"
        onClick={handleClickAddPhoto}
        disabled={isLoading}
      >
        {isLoading ? (
          <Spinner size="sm" />
        ) : (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
            >
              <path
                d="M6.51611 1L6.51611 12.0327"
                stroke="#05073C"
                stroke-width="0.5"
                stroke-linecap="round"
              />
                           {" "}
              <path
                d="M12.0327 6.5166L1 6.5166"
                stroke="#05073C"
                stroke-width="0.5"
                stroke-linecap="round"
              />
            </svg>
             Add more photos        
          </>
        )}
      </button>
    </div>
  );
};

export default CPSelectedPhotosContainer;
